export default __webpack_public_path__ + "v3.412/youtube-logo.png";